import styled from 'styled-components';
import { FunctionComponent } from 'react';
import { Flex } from '@gmg/gmg-react-components';
import { useTranslation } from 'react-i18next';

interface TableSkeletonProps {
    title: string;
    children?: React.ReactNode;
}

export const TableSkeleton: FunctionComponent<TableSkeletonProps> = props => {
    const { t } = useTranslation();

    return (
        <Container>
            <Flex justifyContent='space-between' pr='84px'>
                <span className="px12_600_normal" role="heading" aria-level={3} aria-label={props.title}>
                    {props.title}
                </span>
                <Flex gap='30px'>
                    <span className="px12_600_normal" aria-label={props.title}>
                        {t('TableSkeleton.version', 'VERSION')}
                    </span>
                    <span className="px12_600_normal" aria-label={props.title}>
                        {t('TableSkeleton.help_center', 'HELP CENTER')}
                    </span>
                </Flex>
            </Flex>
            <Flex flexDirection="column" aria-label={`${props.title} Table`} className='vertical-scrollbar'
                height='fit-content'>
                {props.children}
            </Flex>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: fit-content;
    padding: 24px;
    background-color: ${props => props.theme.colors.background};
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding-right: 84px;
`;